import { Table } from "antd";
import React from "react";

const OrganizationTable = ({ columns, tableData }) => {
  return (
    <div className="tableContainerStyling care-plan-table">
      <div className="scroll-container" id="scrollableDiv">
        <Table
          className="tableStyling"
          columns={columns}
          dataSource={tableData?.map((item, index) => ({
            ...item,
            key: index,
          }))}
          pagination={false}
        />
      </div>
    </div>
  );
};

export default OrganizationTable;
